/*
 * <copyright company="Argenbright Innovations Lab">
 *        copyright (c) Argenbright Innovations Lab, an Argenbright Holdings Company.  All rights reserved.
 * </copyright>
 */
/* eslint-disable sonarjs/cognitive-complexity */
import React from 'react';
import { Controller, Control } from 'react-hook-form';
import { TextField, Box, InputAdornment } from '@mui/material';
import { SxProps } from '@mui/system';
import { Icons } from '../../../../../../Shared/Constants/Icons';

interface IBiAnnualScheduleProps {
  control: Control<any>;
  textFieldStyle?: SxProps;
  label?: React.ReactNode;
}

const BiAnnualSchedule: React.FC<IBiAnnualScheduleProps> = ({ control, textFieldStyle, label }) => {
  const labels = ['MM-DD (Jan–June)', 'MM-DD (July–Dec)'];
  return (
    <>
      {label}
      <Box sx={{ display: 'flex', alignItems: 'center', padding: '0.75rem 0', gap: 2 }}>
        {[0, 1].map((index) => (
          <Box key={index} sx={{ flex: 1 }}>
            <Controller
              control={control}
              name={`scheduleDays.${index}`}
              render={({ field: { onChange, value } }) => {
                const displayValue = (() => {
                  if (!value) return '';
                  if (typeof value === 'string' && value.startsWith('M')) {
                    const parts = value.substring(1).split('-');
                    if (parts.length === 2) {
                      return `${parts[0].padStart(2, '0')}-${parts[1].padStart(2, '0')}`;
                    }
                  }
                  return value;
                })();

                return (
                  <TextField
                    fullWidth
                    sx={textFieldStyle}
                    label={labels[index]}
                    value={displayValue}
                    onChange={(e) => {
                      const newValue = e.target.value;
                      if (newValue.length === 5 && newValue.includes('-')) {
                        const [month, day] = newValue.split('-');
                        onChange(`M${parseInt(month)}-${parseInt(day)}`);
                      } else {
                        onChange(newValue);
                      }
                    }}
                    onBlur={(e) => {
                      if (e.target.value.includes('-')) {
                        const [month, day] = e.target.value.split('-');
                        onChange(`M${parseInt(month || '0')}-${parseInt(day || '0')}`);
                      }
                    }}
                    placeholder="MM-DD"
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          {displayValue && (
                            <img
                              src={Icons.CancelIcon}
                              onClick={() => onChange('')}
                              style={{ cursor: 'pointer' }}
                              alt="Clear"
                            />
                          )}
                        </InputAdornment>
                      ),
                    }}
                  />
                );
              }}
            />
          </Box>
        ))}
      </Box>
    </>
  );
};

export default BiAnnualSchedule;
